"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Tabs = _interopRequireDefault(require("@material-ui/core/Tabs"));

var _Tab = _interopRequireDefault(require("@material-ui/core/Tab"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _SystemIcon = _interopRequireDefault(require("../../protons/icons/SystemIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      "& .MuiTab-root.Mui-selected": {
        "letter-spacing": "-0.04em"
      }
    },
    tabRoot: {
      minWidth: function minWidth(_ref) {
        var _minWidth = _ref.minWidth;
        return _minWidth;
      }
    }
  };
});
/**
 * ** Tabs organise content across different screens, data sets, and other interactions. **
 * @param tabs for the tabs
 * @param value valie
 * @param centered
 * @param action
 * @param asMenu
 * @returns {JSX.Element}
 * @constructor
 */

var Tabs = function Tabs(_ref2) {
  var tabs = _ref2.tabs,
      value = _ref2.value,
      centered = _ref2.centered,
      action = _ref2.action,
      minWidth = _ref2.minWidth,
      asMenu = _ref2.asMenu;
  var classes = useStyles({
    minWidth: minWidth
  });

  var handleChange = function handleChange(event, newValue) {
    action(newValue);
  };

  return /*#__PURE__*/_react.default.createElement(_Tabs.default, {
    value: value,
    indicatorColor: "primary",
    onChange: handleChange,
    centered: centered,
    variant: centered ? "standard" : "scrollable",
    className: classes.root
  }, tabs.map(function (tab) {
    return /*#__PURE__*/_react.default.createElement(_Tab.default, {
      className: classes.tabRoot,
      key: tab,
      label: tab,
      icon: asMenu && /*#__PURE__*/_react.default.createElement(_SystemIcon.default, {
        icon: "ic_menu",
        color: "grey"
      }),
      "data-testid": "".concat(tab.toLowerCase().replace(' ', '-'), "-id")
    });
  }));
};

Tabs.propTypes = {
  /** Array of the tabs  */
  tabs: _propTypes.default.array.isRequired,

  /** The selected index item  */
  value: _propTypes.default.number,

  /** Center the tabs in the available space  */
  centered: _propTypes.default.bool,

  /** Callback fired when the value changes. function(value: any) => void  */
  action: _propTypes.default.func,

  /** min width of tab */
  minWidth: _propTypes.default.string
};
var _default = Tabs;
exports.default = _default;